<template>
    <div class="main-data-tabledata">
        <div class="search-content">
            <SearchTools :searchField="searchField" :key="timer" @searchData="searchData">

            </SearchTools>
        </div>
        <DynamicTable
            ref="dynamicTable"
            :showSummary="showSummary"
            :tableColumns="tableColumns"
            :fieldsList="fieldsList"
            :subformTableColumns="subformTableColumns"
            :tableData="pageData"
            :pager="page"
            :isLoading="tableLoading"
            :isShowCheckbox="isModelForm"
            :isSortable="true"
            :isColumnDrop="true"
            :isSubform="isSubform"
            :isShowPageSizes="true"
            :isShowOverflowTooltip="isShowOverflowTooltip"
            :tableHeight="tableHeight"
            :autoHeight="false"
            :isShowProcessInfo="isShowProcessInfo"
            :isViewApprovalInfo="isViewApprovalInfo"
            :key="time"
            :approvalList="approvalList"
            :minuend="minuend"
            :hiddenPage="hiddenPage"
            @filterChange="chooseApprovalStatusField"
            @rowClick="handelSelectRow"
            @rowDblclick="handelDbSelectRow"
            @changePageSize="queryFormDataByPageSize"
            @changePage="queryFormData"
            @searchOrderby="searchOrderby"
            @selectionChange="selectMore">
        </DynamicTable>
         <el-dialog
              title=""
              :visible.sync="isShowOrgTreeDialog"
              :fullscreen = true
              append-to-body
              >
              <VueOrgTree ref="reportOrgTree" :key="loadTimerReport" :treeData="treeOrgData" :hideAllBtn="false" @modelComplete="handleModelReportComplete"/>
          </el-dialog>
          <el-dialog
              width="95%"
              top="1vh"
              class="popEditModelDetail"
              :fullscreen=true
              :visible.sync="active"
              append-to-body
              @close="hideDialog">
                <ModelDetail
                  v-if="isShowModelDetail"
                  :isShowForm="isShowForm"
                  ref="modelInstance"
                  :isRead="isRead"
                  :formInfo="formInfo"
                  @modelComplete="handleModelComplete"
                  @setIsShowForm="setIsShowForm"
              />
          </el-dialog>
    </div>
</template>

<script>
import { getModelFormReportList, getModelFormInstanceById, getModelFormReportOrgTree, saveAppModelForm } from '@/data-model';
import VueOrgTree from '@/components/VueOrgTree';
import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
import { cloneDeep } from 'lodash';
import SearchTools from './SearchTools';

export default {
    components: {
        VueOrgTree,
        ModelDetail,
        SearchTools
    },
    props: {
        selectedModel: {
            type: Object
        },
        modelId: {
            type: String
        },
        formId: {
            type: String
        },
        modelObj: {
            type: Object
        },
        minuend: {
            type: Number,
            default: 300
        },
        tableHeight: {
            type: String
        },
        searchCondition: {
            type: Array
        },
        selectedFields: {
            type: String
        },
        itemRef: {
            type: Object
        },
        showSearchList: {
            type: Array
        },
        hiddenPage: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            formInfo: {},
            isRead: false,
            isShowForm: false,
            isShowModelDetail: false,
            active: false,
            treeOrgData: {},
            loadTimerReport: '',
            isShowOrgTreeDialog: false,
            showSummary: false, // 是否要显示求和
            tableColumns: [],
            fieldsList: [],
            subformTableColumns: [],
            pageData: [],
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            tableLoading: false,
            isModelForm: false, // 是否模型表单
            isSubform: false, // 是否包含子表单
            isShowOverflowTooltip: true,
            isShowProcessInfo: false, // 是否显示流程
            isViewApprovalInfo: false, // 是否显示审批状态和审批详情
            time: new Date().getTime(),
            approvalList: [],
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                isDashBoard: '1'
            },
            formBtnAuth: {// 表单按钮权限
                isShowView: true, // 查看
                isShowAdd: false, // 新增
                isShowEdit: true, // 修改
                isShowDelete: false, // 删除
                isShowImport: false, // 导入
                isShowExport: false, // 导出
                isShowSyn: false// 同步流程数据
            },
            notShowAllField: true,
            searchField: [],
            timer: ''
        };
    },
    created () {
        if (this.modelId) {
            this.renderFormList(this.modelObj, true);
            if (this.showSearchList && this.showSearchList.length > 0) {
                this.searchField = cloneDeep(this.showSearchList);
            }
        }
    },
    methods: {
        queryFormData ({currentPage}) {
            this.isInit = false;
            this.page.currentPage = currentPage;
            this.renderFormList(this.modelObj);
        },
        gefieldFormList (selectedFields, searchCondition, modelObj) {
            this.searchParams.selectedFields = selectedFields;
            this.searchParams.searchCondition = searchCondition;
            this.renderFormList(modelObj, false, searchCondition);
        },
        gefieldAllFormList (selectedFields, searchCondition, modelObj) {
            this.searchParams.selectedFields = selectedFields;
            this.searchParams.searchCondition = searchCondition;
            this.notShowAllField = false;
            this.renderFormList(modelObj, false, searchCondition);
        },
        async renderFormList (model, isInitSearch, searchCondition) {
            this.destoryTable = true;
            if (this.oldSelectedModel && this.oldSelectedModel.id !== model.id) {
                this.oldSelectedModel = model;
                this.isRefreshSel = true;
                this.isRefreshCondition = true;
                this.searchParams.selectedApprovalStatus = '';// 初始化审批状态查询条件
                this.sourceOptions = [];
            }
            if (model.modelType > 1) {
                this.isModelForm = false;
            } else {
                this.isModelForm = true;
            }
            this.tableColumns = [];
            this.fieldsList = [];
            this.isSubform = false;
            this.tableLoading = true;
            this.searchParams.modelId = model.id;
            this.searchParams.formId = model.formId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = this.isFilterDuplicateData;
            if (searchCondition && searchCondition.length > 0) {
                this.searchParams.searchCondition = searchCondition;
            } else {
                this.searchParams.searchCondition = this.searchCondition;
            }
            if (this.selectedFields !== '' && this.notShowAllField) {
                this.searchParams.selectedFields = this.selectedFields;
            }
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            this.pageData = [];
            if (formData.data) {
                let tableDatas = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                });
                this.pageData = tableDatas;
            }
            if (formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                this.allTableColumns = cloneDeep(_tableColumns);
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            if (formData.otherData.fieldsList) {
                this.fieldsList = formData.otherData.fieldsList;
            }
            if (isInitSearch) {
                this.$emit('refreshSearchConditon', this.tableColumns);
            }
            this.subformTableColumns = formData.otherData.subformTableColumns;
            if (this.isInit) {
                this.isApprovalForm = formData.otherData.isApprovalForm;
            }
            if (formData.otherData.approvalList) {
                this.approvalList = formData.otherData.approvalList;
            }
            this.isShowDown = formData.otherData.isShowDown;
            if (this.$refs.dynamicTable) {
                this.$refs.dynamicTable.setMergeSpanArr(this.pageData);
            }
            this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;
            this.filterSumTableColumns();
            this.time = new Date().getTime();
        },
        async chooseApprovalStatusField (approvalStatus) {
            this.searchParams.selectedApprovalStatus = approvalStatus;
            this.queryFormData(1);
        },
        async handelSelectRow (params) {
            // console.log(this.isModelForm);
            if (this.isModelForm) {
                this.handleNavModelFormEdit(params.row);
            }
        },
        async handelDbSelectRow (params) {
            if (this.itemRef && this.itemRef.dataType === 4) { // 报表类型,点击双击查看百川金字塔
                this.showOrgTreeView(params.row);
            }
        },
        async showOrgTreeView (row) { // 点击报表界面数据弹出对应数据一对多的百川金字塔图
            this.loadTimerReport = new Date().getTime();
            let formData = await getModelFormReportOrgTree(this.formId, row.id);
            this.treeOrgData = {};
            if (formData.data) {
                let tableDatas = {};
                formData.data.forEach(item => {
                    tableDatas = JSON.parse(item);
                });
                this.treeOrgData = tableDatas;
            }
            this.isShowOrgTreeDialog = true;
        },
        queryFormDataByPageSize ({pageSize}) {
            this.isInit = false;
            this.page.pageSize = pageSize;
            this.renderFormList(this.modelObj);
        },
        searchOrderby (searchItem) {
            this.searchParams.searchCondition = [];
            this.searchParams.searchCondition.push(searchItem);
            this.queryFormData(1);
        },
        selectMore (params) {
            this.isHasUNDel = params.isHasUNDel;
            this.moreIds = params.ids;
            this.unDelNums = params.unDelNums;
        },
        getIfSubform (tableColumns) {
            let isSubform = false;
            for (var i = 0; i < tableColumns.length; i++) {
                if (tableColumns[i].subcolumn) {
                    isSubform = true;
                    break;
                }
            }
            return isSubform;
        },
        filterSumTableColumns () { // 过滤出需要求和的字段list
            this.isCanShowSummery = false;
            this.hasLinkField = false;
            this.tableColumns.forEach((mainItem, index) => {
                if (mainItem.type === 'number' || mainItem.type === 'calculation') {
                    this.isCanShowSummery = true;
                }
                if (mainItem.type === 'subform') {
                    let subColumns = mainItem.subColumns;
                    subColumns.forEach((subItem) => {
                        if (subItem.type === 'number' || subItem.type === 'calculation') {
                            this.isCanShowSummery = true;
                        }
                    });
                }
                if (mainItem.type === 'link') {
                    this.hasLinkField = true;
                }
            });
        },
        async handleNavModelFormEdit (row) {
            this.formInfo = await getModelFormInstanceById(row.id);
            if (this.formInfo) {
                this.formInfo.modelName = this.modelObj.modelName;
                this.formInfo.appName = this.modelObj.fappName;
                this.formInfo.remarks = this.modelObj.remarks;
                this.formInfo.modelType = this.modelObj.modelType;
                this.isShowModelDetail = true;
                this.isShowForm = false;
                this.isRead = false;
                row.isCanEdit = this.getEditAuth();
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.modelInstance.loadFormData(this.formInfo, this.formBtnAuth, row, this.isShowDown);
                }, 0);
            }
            this.active = true;
        },
        getTableColumns () {
            return this.tableColumns;
        },
        async handleModelReportComplete (model) {
            await saveAppModelForm(model.modelId, model);
            this.isShowOrgTreeDialog = false;
            await this.queryFormData(this.page);
        },
        async handleModelComplete (model) {
            await saveAppModelForm(this.modelObj.id, model);
            await this.queryFormData(this.page);
            this.active = false;
        },
        setIsShowForm (status) {
            this.isShowForm = status;
        },
        hideDialog () {
            this.active = false;
            this.isShowModelDetail = false;
        },
        getEditAuth () {
            let isEditAuth = false;
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                let resources = currentUserInfo.resources;
                if (resources) {
                    for (let i = 0; i < resources.length; i++) {
                        if (resources[i].resourceUrl === 'ReportFormDataEditBtn') { // 是否可以点击报表进行数据修改
                            isEditAuth = true;
                            break;
                        }
                    }
                }
            }
            return isEditAuth;
        },
        renderSearchField (o) {
            this.searchField = cloneDeep(o);
            this.timer = new Date().getTime();
        },
        searchData (arr) {
            this.renderFormList(this.modelObj, false, arr);
        }
    }
};
</script>

<style lang="less">
.main-data-tabledata{
  .popEditModelDetail{
      .el-dialog__body {
        padding: 5px 30px 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
        height: calc(100% - 8vh);
      }
    }
}


</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/TableData.vue